<template>
    <div class="bid-box">
        <table class="layui-table" v-if="unitKind=='1'">
            <colgroup>
                <col width="100">
                <col width="100">
                <col width="100">
                <col width="100">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>序号</th>
                    <th>阶段</th>
                    <th>工程节点</th>
                    <th>文件资料</th>
                    <th>内容</th>
                </tr> 
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td rowspan="5">支付阶段</td>
                    <td>预付款</td>
                    <td style="text-align: left;">
                        <p v-if="edit" style="width:100%">
                            <el-checkbox v-model="accept.advanceCharge.flag">无</el-checkbox>
                        </p>
                        <p v-else  style="width:100%">
                            <el-checkbox v-model="accept.advanceCharge.flag" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td style="text-align: left;">
                        <div v-for="item in accept.advanceCharge.list" :key="item.id" style="margin-bottom:2vh;">
                            <div style="display:flex;justify-content: space-between;width:100%"  v-if="!accept.advanceCharge.flag">  
                                <div style="width:30%">
                                    <el-date-picker
                                        v-model="item.time"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div style="width:36%">
                                    <el-input v-if="edit" type="number"  @input="getInputvalue" v-model="item.payMoney" autocomplete="off"></el-input>
                                    <el-input v-else type="number"  @input="getInputvalue" v-model="item.payMoney" autocomplete="off" disabled></el-input>
                                    万元
                                </div>
                                <el-upload
                                        class="upload-demo"
                                        :action="uploadUrl"
                                        :headers="uploadHead"
                                        :data="{type:232}"
                                        :objectBind='item.key'
                                        :on-success="handleSuccess"
                                        :on-remove="handleDel"
                                            multiple
                                        :file-list="item.filename">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <div style="display:flex" class="recommends-content-item" v-if="edit">
                                    <i  class="el-icon-circle-plus-outline" @click="add"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                    <div class="recommends-content-item__info" >
                                        <i  class="el-icon-delete"  @click="reduce(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                    </div>
                                </div>  
                            </div>
                                
                        </div>
                        <div v-if="!accept.advanceCharge.flag">
                            统计：{{accept.advanceCharge.total1}}万元
                        </div>  
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>进度款</td>
                    <td style="text-align: left;">
                        <p style="width:100%;padding-bottom: 10px;">
                            <el-checkbox v-if="edit"  v-model="accept.first.flag">无</el-checkbox>
                            <el-checkbox v-else   v-model="accept.first.flag" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td style="text-align: left;">
                        <div v-for="item in accept.first.list" :key="item.id" style="margin-bottom:2vh;">                          
                            <div style="display:flex;" v-if="!accept.first.flag">
                                <div style="width:20%">时间：
                                    <el-date-picker
                                        v-model="item.time"
                                        type="date"
                                        style="width: 140px;"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div style="width:30%">审定产值：
                                    <el-input v-if="edit"  @input="getAppr1"  type="number" style="width:8vw;" v-model="item.apprMoney" autocomplete="off">
                                    </el-input> 
                                    <el-input v-else disabled  @input="getAppr1"  type="number" style="width:8vw;" v-model="item.apprMoney" autocomplete="off">
                                    </el-input> 
                                    万元
                                </div>
                                <div style="width:30%">本次支付：
                                    <el-input v-if="edit"  @input="getInputvalue1"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off">
                                    </el-input> 
                                    <el-input v-else disabled  @input="getInputvalue1"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off">
                                    </el-input> 
                                    万元
                                </div>
                                    
                                <div style="width:30%">农民工专户支付：
                                    <el-input v-if="edit" @input="getInputvalue2"  type="number" style="width:8vw;"  v-model="item.baseMoney" autocomplete="off">  
                                    </el-input> 
                                    <el-input v-else disabled @input="getInputvalue2"  type="number" style="width:8vw;"  v-model="item.baseMoney" autocomplete="off">  
                                    </el-input> 万元
                                </div>
                                <div style="width:30%">违约金：
                                    <el-input v-if="edit" @input="getDamages"  type="number" style="width:8vw;"  v-model="item.damMoney" autocomplete="off">  
                                    </el-input> 
                                    <el-input v-else disabled @input="getDamages"  type="number" style="width:8vw;"  v-model="item.damMoney" autocomplete="off">  
                                    </el-input> 万元
                                </div>
                                <el-upload
                                    class="upload-demo"
                                    style="width:30%;padding-left:1vh;"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.key'
                                    :on-success="handleSuccess1"
                                    :on-remove="handleDel1"
                                    multiple
                                    :file-list="item.filename">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <div style="display:flex" class="recommends-content-item" v-if="edit"> 
                                    <i  class="el-icon-circle-plus-outline" @click="add1"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                    <div class="recommends-content-item__info" >
            
                                    <i  class="el-icon-delete"  @click="reduce1(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!accept.first.flag" style="display:flex;width:80%;justify-content: space-between;">
                            <div  style="margin-right:50px;"> 审定统计：{{accept.first.total0}}万元</div>
                            <div  style="margin-right:50px;"> 金额统计：{{accept.first.total2}}万元</div>
                            <div> 农民工专户统计：{{accept.first.total3}}万元</div>
                            <div style="margin-right:50px;"> 违约金统计：{{accept.first.total4}}万元</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>终审款</td>
                    <td style="text-align: left;">
                        <p style="width:100%;padding-bottom: 10px;">
                            <el-checkbox v-if="edit" v-model="accept.finall.flag" >无</el-checkbox>
                            <el-checkbox v-else  v-model="accept.finall.flag" disabled>无</el-checkbox>
                        </p>   
                    </td>
                    <td style="text-align: left;">  
                        <div v-for="item in accept.finall.list" :key="item.id" style="margin-bottom:2vh;">                          
                            <div style="display:flex" v-if="!accept.finall.flag">
                                <div style="width:20%;padding-top: 20px;">
                                    <el-date-picker
                                        v-model="item.time"
                                        type="date"
                                        style="width: 140px;"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div style="width:20%"><span>终审价：</span>
                                    <el-input v-if="edit" @input="setLast"  type="number" style="width:8vw;" v-model="item.lastMoney" autocomplete="off"></el-input> 
                                    <el-input v-else disabled  type="number" style="width:8vw;" v-model="item.lastMoney" autocomplete="off"></el-input> 
                                万元</div>
                                <div style="width:20%">本次支付：
                                    <el-input v-if="edit" @input="getInputvalue5"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off"></el-input> 
                                    <el-input v-else disabled  @input="getInputvalue5"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off"></el-input> 
                                    
                                万元</div>
                                <div style="width:20%">专户支付：
                                    <el-input v-if="edit" @input="getInputvalue6"  type="number" style="width:8vw;" v-model="item.baseMoney" autocomplete="off"></el-input> 
                                    <el-input v-else disabled @input="getInputvalue6"  type="number" style="width:8vw;" v-model="item.baseMoney" autocomplete="off"></el-input> 
                                万元</div>
                                <el-upload
                                    class="upload-demo"
                                    style="width:30%;padding-left:1vh;"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.key'
                                    :on-success="handleSuccess4"
                                    :on-remove="handleDel4"
                                    multiple
                                    :file-list="item.filename">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                    <div style="display:flex" class="recommends-content-item" v-if="edit">
                                        <i  class="el-icon-circle-plus-outline" @click="add4"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                        <div class="recommends-content-item__info" >
                                        <i  class="el-icon-delete"  @click="reduce4(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                        </div>
                                    </div>  
                            </div>                       
                        </div>
                        <div v-if="!accept.finall.flag" style="display:flex;width:65%;justify-content: space-between;padding-left:15%;">
                            <div  style="margin-right:50px"> 终审统计：{{accept.finall.total4}} 万元</div>
                            <div  style="margin-right:50px"> 金额统计：{{accept.finall.total5}} 万元</div>
                            <div> 专户统计：{{accept.finall.total6}}万元</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>质保款</td>
                    <td style="text-align: left;"></td>
                    <td style="text-align: left;">
                        <div  v-for="item in accept.quality.list" :key="item.id" style="margin-bottom:2vh;">
                            <div style="display:flex;width:100%;"  v-if="!accept.quality.flag">  
                                <div style="width:30%">
                                    <el-date-picker
                                        v-model="item.time"
                                        type="date"
                                        value-format="yyyy-MMM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div style="width:30%">
                                    <el-input v-if="edit" @input="getInputvalue3" type="number" v-model="item.payMoney" autocomplete="off"></el-input> 
                                    <el-input v-else @input="getInputvalue3" type="number" v-model="item.payMoney" autocomplete="off" disabled></el-input>
                                    万元
                                </div>
                                <el-upload
                                        class="upload-demo"
                                        :action="uploadUrl"
                                        :headers="uploadHead"
                                        :data="{type:232}"
                                        :objectBind='item.key'
                                        :on-success="handleSuccess2"
                                        :on-remove="handleDel2"
                                        :file-list="item.filename">
                                    <el-button  v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            <div style="display:flex" class="recommends-content-item" v-if="edit">
                                <i  class="el-icon-circle-plus-outline" @click="add2"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                <div class="recommends-content-item__info" >

                                <i  class="el-icon-delete"  @click="reduce2(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                </div>
                            </div>  
                            </div>
                                
                        </div>
                        <div v-if="!accept.quality.flag">
                        统计：{{accept.quality.total4}} 万元
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>其他</td>
                    <td style="text-align: left;">
                        <p style="width:100%">
                            <el-checkbox v-if="edit" v-model="accept.otherFile.flag" @change="changeStatus">无</el-checkbox>
                            <el-checkbox v-else v-model="accept.otherFile.flag" @change="changeStatus" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td style="text-align: left;">
                        <div  v-for="item in accept.otherFile.list" :key="item.id" style="margin-bottom:1vh;">
                            <div style="display:flex;justify-content: space-between;width:50%"  v-if="!accept.otherFile.flag">  
                                <div style="width:66%"><el-input v-model="item.payMoney" autocomplete="off"></el-input></div>
                                <el-upload
                                        class="upload-demo len100"
                                        :action="uploadUrl"
                                        :headers="uploadHead"
                                        :data="{type:232}"
                                        :objectBind='item.key'
                                        :on-success="handleSuccess3"
                                        :on-remove="handleDel3"
                                            multiple
                                        :file-list="item.filename">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            <div style="display:flex" class="recommends-content-item" v-if="edit">
                                <i  class="el-icon-circle-plus-outline" @click="add3"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                <div class="recommends-content-item__info" >
                                <i  class="el-icon-delete"  @click="reduce3(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                </div>
                            </div>    
                            </div>      
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="layui-table" v-if="unitKind=='2'">
            <colgroup>
                <col width="100">
                <col width="100">
                <col width="100">
                <col width="100">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>序号</th>
                    <th>阶段</th>
                    <th>工程节点</th>
                    <th>文件资料</th>
                    <th>内容</th>
                </tr> 
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td rowspan="5">支付阶段</td>
                    <td>预付款</td>
                    <td style="text-align: left;">
                        <p v-if="edit" style="width:100%">
                            <el-checkbox v-model="accept.advanceCharge.flag">无</el-checkbox>
                        </p>
                        <p v-else  style="width:100%">
                            <el-checkbox v-model="accept.advanceCharge.flag" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td style="text-align: left;">
                        <div v-for="item in accept.advanceCharge.list" :key="item.id" style="margin-bottom:2vh;">
                            <div style="display:flex;justify-content: space-between;width:100%"  v-if="!accept.advanceCharge.flag">  
                                <div style="width:30%">
                                    <el-date-picker
                                        v-model="item.time"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div style="width:36%">
                                    <el-input v-if="edit" type="number"  @input="getInputvalue" v-model="item.payMoney" autocomplete="off"></el-input>
                                    <el-input v-else type="number"  @input="getInputvalue" v-model="item.payMoney" autocomplete="off" disabled></el-input>
                                    万元
                                </div>
                                <el-upload
                                        class="upload-demo"
                                        :action="uploadUrl"
                                        :headers="uploadHead"
                                        :data="{type:232}"
                                        :objectBind='item.key'
                                        :on-success="handleSuccess"
                                        :on-remove="handleDel"
                                            multiple
                                        :file-list="item.filename">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <div style="display:flex" class="recommends-content-item" v-if="edit">
                                    <i  class="el-icon-circle-plus-outline" @click="add"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                    <div class="recommends-content-item__info" >
                                        <i  class="el-icon-delete"  @click="reduce(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                    </div>
                                </div>  
                            </div>
                                
                        </div>
                        <div v-if="!accept.advanceCharge.flag">
                            统计：{{accept.advanceCharge.total1}}万元
                        </div>  
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>进度款</td>
                    <td style="text-align: left;">
                        <p style="width:100%;padding-bottom: 10px;">
                            <el-checkbox v-if="edit"  v-model="accept.first.flag">无</el-checkbox>
                            <el-checkbox v-else   v-model="accept.first.flag" disabled>无</el-checkbox>
                        </p>  
                    </td>
                    <td style="text-align: left;">   
                        <div v-for="item in accept.first.list" :key="item.id" style="margin-bottom:2vh;">                          
                            <div style="display:flex;" v-if="!accept.first.flag">
                                <div style="width:25%">时间：
                                    <el-date-picker
                                        v-model="item.time"
                                        type="date"
                                        style="width: 140px;"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div style="width:35%">审定产值：
                                    <el-input v-if="edit"  @input="getAppr1"  type="number" style="width:6vw;" v-model="item.apprMoney" autocomplete="off">
                                    </el-input> 
                                    <el-input v-else disabled  @input="getAppr1"  type="number" style="width:6vw;" v-model="item.apprMoney" autocomplete="off">
                                    </el-input> 
                                    万元
                                </div>
                                <div style="width:35%">本次支付：
                                    <el-input v-if="edit"  @input="getInputvalue1"  type="number" style="width:6vw;" v-model="item.payMoney" autocomplete="off">
                                    </el-input> 
                                    <el-input v-else disabled  @input="getInputvalue1"  type="number" style="width:6vw;" v-model="item.payMoney" autocomplete="off">
                                    </el-input> 
                                    万元
                                </div>
                                    
                                <!-- <div style="width:30%">农民工专户支付：
                                    <el-input v-if="edit" @input="getInputvalue2"  type="number" style="width:8vw;"  v-model="item.baseMoney" autocomplete="off">  
                                    </el-input> 
                                    <el-input v-else disabled @input="getInputvalue2"  type="number" style="width:8vw;"  v-model="item.baseMoney" autocomplete="off">  
                                    </el-input> 万元
                                </div> -->
                                <div style="width:30%">违约金：
                                    <el-input v-if="edit" @input="getDamages"  type="number" style="width:6vw;"  v-model="item.damMoney" autocomplete="off">  
                                    </el-input> 
                                    <el-input v-else disabled @input="getDamages"  type="number" style="width:6vw;"  v-model="item.damMoney" autocomplete="off">  
                                    </el-input> 万元
                                </div>
                                <el-upload
                                    class="upload-demo"
                                    style="width:30%;padding-left:1vh;"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.key'
                                    :on-success="handleSuccess1"
                                    :on-remove="handleDel1"
                                    multiple
                                    :file-list="item.filename">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <div style="display:flex" class="recommends-content-item" v-if="edit"> 
                                    <i  class="el-icon-circle-plus-outline" @click="add1"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                    <div class="recommends-content-item__info" >
            
                                    <i  class="el-icon-delete"  @click="reduce1(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!accept.first.flag" style="display:flex;width:80%;justify-content: space-between;">
                            <div  style="margin-right:50px;"> 审定统计：{{accept.first.total0}}万元</div>
                            <div  style="margin-right:50px;"> 金额统计：{{accept.first.total2}}万元</div>
                            <!-- <div> 农民工专户统计：{{accept.first.total3}}万元</div> -->
                            <div style="margin-right:50px;"> 违约金统计：{{accept.first.total4}}万元</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>终审款</td>
                    <td style="text-align: left;">
                        <p style="width:100%;padding-bottom: 10px;">
                            <el-checkbox v-if="edit" v-model="accept.finall.flag" >无</el-checkbox>
                            <el-checkbox v-else  v-model="accept.finall.flag" disabled>无</el-checkbox>
                        </p> 
                    </td>
                    <td style="text-align: left;">    
                        <div v-for="item in accept.finall.list" :key="item.id" style="margin-bottom:2vh;">                          
                            <div style="display:flex" v-if="!accept.finall.flag">
                                <div style="width:20%;padding-top: 20px;">
                                    <el-date-picker
                                        v-model="item.time"
                                        type="date"
                                        style="width: 140px;"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div style="width:30%"><span>终审价：</span>
                                    <el-input v-if="edit" @input="setLast"  type="number" style="width:8vw;" v-model="item.lastMoney" autocomplete="off"></el-input> 
                                    <el-input v-else disabled  type="number" style="width:8vw;" v-model="item.lastMoney" autocomplete="off"></el-input> 
                                万元</div>
                                <div style="width:30%">本次支付：
                                    <el-input v-if="edit" @input="getInputvalue5"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off"></el-input> 
                                    <el-input v-else disabled  @input="getInputvalue5"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off"></el-input> 
                                    
                                万元</div>
                                <!-- <div style="width:20%">专户支付：
                                    <el-input v-if="edit" @input="getInputvalue6"  type="number" style="width:8vw;" v-model="item.baseMoney" autocomplete="off"></el-input> 
                                    <el-input v-else disabled @input="getInputvalue6"  type="number" style="width:8vw;" v-model="item.baseMoney" autocomplete="off"></el-input> 
                                万元</div> -->
                                <el-upload
                                    class="upload-demo"
                                    style="width:30%;padding-left:1vh;"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.key'
                                    :on-success="handleSuccess4"
                                    :on-remove="handleDel4"
                                    multiple
                                    :file-list="item.filename">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                    <div style="display:flex" class="recommends-content-item" v-if="edit">
                                        <i  class="el-icon-circle-plus-outline" @click="add4"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                        <div class="recommends-content-item__info" >
                                        <i  class="el-icon-delete"  @click="reduce4(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                        </div>
                                    </div>  
                            </div>                       
                        </div>
                        <div v-if="!accept.finall.flag" style="display:flex;width:65%;justify-content: space-between;padding-left:15%;">
                            <div  style="margin-right:50px"> 终审统计：{{accept.finall.total4}} 万元</div>
                            <div  style="margin-right:50px"> 金额统计：{{accept.finall.total5}} 万元</div>
                            <!-- <div> 专户统计：{{accept.finall.total6}}万元</div> -->
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>质保款</td>
                    <td style="text-align: left;"></td>
                    <td style="text-align: left;">
                        <div  v-for="item in accept.quality.list" :key="item.id" style="margin-bottom:2vh;">
                            <div style="display:flex;width:100%;"  v-if="!accept.quality.flag">  
                                <div style="width:30%">
                                    <el-date-picker
                                        v-model="item.time"
                                        type="date"
                                        value-format="yyyy-MMM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </div>
                                <div style="width:30%">
                                    <el-input v-if="edit" @input="getInputvalue3" type="number" v-model="item.payMoney" autocomplete="off"></el-input> 
                                    <el-input v-else @input="getInputvalue3" type="number" v-model="item.payMoney" autocomplete="off" disabled></el-input>
                                    万元
                                </div>
                                <el-upload
                                        class="upload-demo"
                                        :action="uploadUrl"
                                        :headers="uploadHead"
                                        :data="{type:232}"
                                        :objectBind='item.key'
                                        :on-success="handleSuccess2"
                                        :on-remove="handleDel2"
                                        :file-list="item.filename">
                                    <el-button  v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            <div style="display:flex" class="recommends-content-item" v-if="edit">
                                <i  class="el-icon-circle-plus-outline" @click="add2"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                <div class="recommends-content-item__info" >

                                <i  class="el-icon-delete"  @click="reduce2(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                </div>
                            </div>  
                            </div>
                                
                        </div>
                        <div v-if="!accept.quality.flag">
                        统计：{{accept.quality.total4}} 万元
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>其他</td>
                    <td style="text-align: left;">
                        <p  style="width:100%">
                            <el-checkbox v-if="edit" v-model="accept.otherFile.flag" @change="changeStatus">无</el-checkbox>
                            <el-checkbox v-else v-model="accept.otherFile.flag" @change="changeStatus" disabled>无</el-checkbox>
                        </p>
                    </td>
                    <td style="text-align: left;">
                        <div  v-for="item in accept.otherFile.list" :key="item.id" style="margin-bottom:1vh;">
                            <div style="display:flex;justify-content: space-between;width:50%"  v-if="!accept.otherFile.flag">  
                                <div style="width:66%"><el-input v-model="item.payMoney" autocomplete="off"></el-input></div>
                                <el-upload
                                        class="upload-demo len100"
                                        :action="uploadUrl"
                                        :headers="uploadHead"
                                        :data="{type:232}"
                                        :objectBind='item.key'
                                        :on-success="handleSuccess3"
                                        :on-remove="handleDel3"
                                            multiple
                                        :file-list="item.filename">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            <div style="display:flex" class="recommends-content-item" v-if="edit">
                                <i  class="el-icon-circle-plus-outline" @click="add3"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                                <div class="recommends-content-item__info" >
                                <i  class="el-icon-delete"  @click="reduce3(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                                </div>
                            </div>    
                            </div>      
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="edit" style="width:100%;height:8vh;position: relative;position: relative;display: flex;justify-content: center;justify-items: center;align-content: center;align-items: center;">
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button>返回</el-button>
        </div>

        <!-- <el-form ref="form" :model="form" label-width="240px">
            <el-form-item label="所属项目：">
                <span style="color:#296dd3;">{{agreeName}}</span>
            </el-form-item>
            <el-form-item label="预付款">
                <p v-if="edit" style="width:100%">
                    <el-checkbox v-model="accept.advanceCharge.flag">无</el-checkbox>
                </p>
                <p v-else  style="width:100%">
                    <el-checkbox v-model="accept.advanceCharge.flag" disabled>无</el-checkbox>
                </p>
                <div v-for="item in accept.advanceCharge.list" :key="item.id" style="margin-bottom:3vh;">
                    <div style="display:flex;justify-content: space-between;width:50%"  v-if="!accept.advanceCharge.flag">  
                        <div style="width:66%">
                            <el-input v-if="edit" type="number"  @input="getInputvalue" v-model="item.payMoney" autocomplete="off"></el-input>
                            <el-input v-else type="number"  @input="getInputvalue" v-model="item.payMoney" autocomplete="off" disabled></el-input>
                            万元
                        </div>
                        <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :objectBind='item.key'
                                :on-success="handleSuccess"
                                :on-remove="handleDel"
                                    multiple
                                :file-list="item.filename">
                            <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                        <div style="display:flex" class="recommends-content-item" v-if="edit">
                            <i  class="el-icon-circle-plus-outline" @click="add"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                            <div class="recommends-content-item__info" >
                                <i  class="el-icon-delete"  @click="reduce(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>  
                    </div>
                        
                </div>
                <div v-if="!accept.advanceCharge.flag">
                    统计：{{accept.advanceCharge.total1}}万元
                </div>  
            </el-form-item>
            <el-form-item label="初审款："> 
                <p style="width:100%">
                    <el-checkbox v-if="edit"  v-model="accept.first.flag">无</el-checkbox>
                        <el-checkbox v-else   v-model="accept.first.flag" disabled>无</el-checkbox>
                </p>     
                <div v-for="item in accept.first.list" :key="item.id" style="margin-bottom:3vh;">                          
                <div style="display:flex" v-if="!accept.first.flag">
                    <div style="width:25%">本次支付：
                        <el-input v-if="edit"  @input="getInputvalue1"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off">
                        </el-input> 
                        <el-input v-else disabled  @input="getInputvalue1"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off">
                        </el-input> 
                        万元
                </div>
                        
                    <div style="width:30%">基本户支付：
                        <el-input v-if="edit" @input="getInputvalue2"  type="number" style="width:8vw;"  v-model="item.baseMoney" autocomplete="off">  
                        </el-input> 
                        <el-input v-else disabled @input="getInputvalue2"  type="number" style="width:8vw;"  v-model="item.baseMoney" autocomplete="off">  
                        </el-input> 万元
                    </div>
                    <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :headers="uploadHead"
                        :data="{type:232}"
                        :objectBind='item.key'
                        :on-success="handleSuccess1"
                        :on-remove="handleDel1"
                        multiple
                        :file-list="item.filename">
                        <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                    </el-upload>
                        <div style="display:flex" class="recommends-content-item" v-if="edit"> 
                            <i  class="el-icon-circle-plus-outline" @click="add1"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                            <div class="recommends-content-item__info" >
    
                            <i  class="el-icon-delete"  @click="reduce1(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>  

                </div>
                
                </div>
                    <div v-if="!accept.first.flag" style="display:flex;width:35%;justify-content: space-between;">
                        <div  style="margin-right:50px"> 金额统计:{{accept.first.total2}}万元</div>
                        <div> 基本户统计:{{accept.first.total3}}万元</div>
                    </div>
            </el-form-item>
                <el-form-item label="终审款："> 
                <p style="width:100%">
                    <el-checkbox v-if="edit" v-model="accept.finall.flag" >无</el-checkbox>
                    <el-checkbox v-else  v-model="accept.finall.flag" disabled>无</el-checkbox>
                </p>     
                <div v-for="item in accept.finall.list" :key="item.id" style="margin-bottom:3vh;">                          
                <div style="display:flex" v-if="!accept.finall.flag">
                    <div style="width:25%">本次支付：
                        <el-input v-if="edit" @input="getInputvalue5"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off"></el-input> 
                        <el-input v-else disabled  @input="getInputvalue5"  type="number" style="width:8vw;" v-model="item.payMoney" autocomplete="off"></el-input> 
                        
                    万元</div>
                    <div style="width:30%">基本户支付：
                        <el-input v-if="edit" @input="getInputvalue6"  type="number" style="width:8vw;" v-model="item.baseMoney" autocomplete="off"></el-input> 
                        <el-input v-else disabled @input="getInputvalue6"  type="number" style="width:8vw;" v-model="item.baseMoney" autocomplete="off"></el-input> 
                    万元</div>
                    <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :headers="uploadHead"
                        :data="{type:232}"
                        :objectBind='item.key'
                        :on-success="handleSuccess4"
                        :on-remove="handleDel4"
                        multiple
                        :file-list="item.filename">
                        <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                    </el-upload>
                        <div style="display:flex" class="recommends-content-item" v-if="edit">
                            <i  class="el-icon-circle-plus-outline" @click="add4"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                            <div class="recommends-content-item__info" >
                            <i  class="el-icon-delete"  @click="reduce4(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>  
                </div>                       
                </div>
                    <div v-if="!accept.finall.flag" style="display:flex;width:35%;justify-content: space-between;">
                        <div  style="margin-right:50px"> 金额统计：{{accept.finall.total5}} 万元</div>
                        <div> 基本户统计：{{accept.finall.total6}}万元</div>
                    </div>
            </el-form-item>
            <el-form-item label="质保款：">
                <div  v-for="item in accept.quality.list" :key="item.id" style="margin-bottom:3vh;">
                    <div style="display:flex;justify-content: space-between;width:50%;"  v-if="!accept.quality.flag">  
                        <div style="width:66%">
                            <el-input v-if="edit" @input="getInputvalue3" type="number" v-model="item.payMoney" autocomplete="off"></el-input> 
                            <el-input v-else @input="getInputvalue3" type="number" v-model="item.payMoney" autocomplete="off" disabled></el-input>
                            万元
                        </div>
                        <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :objectBind='item.key'
                                :on-success="handleSuccess2"
                                :on-remove="handleDel2"
                                :file-list="item.filename">
                            <el-button  v-if="edit" size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    <div style="display:flex" class="recommends-content-item" v-if="edit">
                        <i  class="el-icon-circle-plus-outline" @click="add2"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                        <div class="recommends-content-item__info" >

                        <i  class="el-icon-delete"  @click="reduce2(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                        </div>
                    </div>  
                    </div>
                        
                </div>
                <div v-if="!accept.quality.flag">
                统计：{{accept.quality.total4}} 万元
                </div>   
            </el-form-item>
                <el-form-item label="其他:">
                        <p  style="width:100%">
                            <el-checkbox v-if="edit" v-model="accept.otherFile.flag" @change="changeStatus">无</el-checkbox>
                            <el-checkbox v-else v-model="accept.otherFile.flag" @change="changeStatus" disabled>无</el-checkbox>
                        </p>
                    <div  v-for="item in accept.otherFile.list" :key="item.id" style="margin-bottom:3vh;">
                        <div style="display:flex;justify-content: space-between;width:50%"  v-if="!accept.otherFile.flag">  
                            <div style="width:66%"><el-input v-model="item.payMoney" autocomplete="off"></el-input></div>
                            <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.key'
                                    :on-success="handleSuccess3"
                                    :on-remove="handleDel3"
                                        multiple
                                    :file-list="item.filename">
                                <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        <div style="display:flex" class="recommends-content-item" v-if="edit">
                            <i  class="el-icon-circle-plus-outline" @click="add3"  style="color:#296dd3;font-size:3vh;cursor: pointer;"  alt="" srcset=""></i>
                            <div class="recommends-content-item__info" >
                            <i  class="el-icon-delete"  @click="reduce3(item.index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div>    
                        </div>      
                    </div>
                    <div>
                    </div>     
            </el-form-item>
            <el-form-item v-if="edit">
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button>返回</el-button>
            </el-form-item>
        </el-form> -->
    </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import stage from '../../untils/agree'
import base from '../../untils/base'
export default {
    data(){
        return{
            contractId:"",
            id:'',
            status:'',
            unitKind:'',
            agreeName:'',
            groupId:'',
            activeName:'first',
            form:{
                name:'',
            },
            uploadUrl:myHttp.uploadFile, //上传地址
            uploadHead:{
                accessToken: util.session.get('token')
            },
            checked:false,
            money:'',
            stage1:stage.payFile,
            entity:{
                advanceCharge:[{total1:0,flag:false,list:[{index:0,payMoney:'',filename:[],time:''}]}],
                first:[{total2:0,total3:0,flag:false,list:[{index:0,payMoney:'',baseMoney:'',filename:[],apprMoney:'',damMoney:'',time:''}]}],
                finall:[{total4:0,total5:0,total6:0,flag:false,list:[{index:0,lastMoney:'',payMoney:'',baseMoney:'',filename:[],time:''}]}],
                quality:[{total4:0,flag:false,list:[{index:0,payMoney:'',filename:[],time:''}]}],
                otherFile:[{flag:false,list:[{index:0,payMoney:'',filename:[],}]}],
            },
            accept:{
                advanceCharge:{
                    flag:false,
                    list:[
                        {index:0,payMoney:'',filename:[],time:''}
                    ],
                    total1:0,
                },
                first:{
                    flag:false,
                    list:[
                        {index:0,payMoney:'',baseMoney:'',filename:[],apprMoney:'',damMoney:'',time:''}
                    ],
                    total0:0,
                    total2:0,
                    total3:0,
                    total4:0,
                },
                finall:{
                    flag:false,
                    list:[
                        {index:0,lastMoney:'',payMoney:'',baseMoney:'',filename:[],time:''}
                    ],
                    total4:0,
                    total5:0,
                    total6:0,
                },
                quality:{
                    flag:false,
                    list:[
                        {index:0,payMoney:'',filename:[],time:''}
                    ],
                    total4:0,
                },
                otherFile:{
                    flag:false,
                    list:[
                        {index:0,payMoney:'',filename:[],}
                    ],
                },
            },
            edit:false
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.id = params.id
        this.status = params.status
        this.getInfo()
        this.getData1()
        this.edit = util.session.get('principalId')== util.session.get('user').id?true:false
        // console.log(this.edit)
    },
    methods:{
        
        /**************预付款文件上传 */
          //监听上传文件
        handleChange(file, fileList){
            // this.fileList = fileList.slice(-3);
            // console.log(fileList)
        },
        //上传文件成功
        handleSuccess(res, file,opt,other){
            console.log(res,file.opt,other)
            var typeName=file.name.substring(file.name.lastIndexOf('.')+1)
              console.log(typeName)
            if(res.code=='200'){
                // this.$message.success();
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other,
                    typeName:typeName
                }
                for(var i=0;i<this.accept.advanceCharge.list.length;i++){
                    if(this.accept.advanceCharge.list[i].index==other){
                        this.accept.advanceCharge.list[i].files.push(obj)  
                    }
                     console.log( this.accept.advanceCharge.list)
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        //监听文件删除
         handleDel(file,fileList){
            for(var i=0;i<this.accept.advanceCharge.list.length;i++){
                if(this.accept.advanceCharge.list[i].index==file.index){
                    for(var j=0;j<this.accept.advanceCharge.list[i].files.length;j++){
                        this.accept.advanceCharge.list[i].files.splice(j,1)
                    }
                }
            }
        },


        /**************初审款文件上传 */
       //监听上传文件
        handleChange1(file, fileList){
            // this.fileList = fileList.slice(-3);
            // console.log(fileList)
        },
        //上传文件成功
        handleSuccess1(res, file,opt,other){
                if(res.code=='200'){
                // this.$message.success();
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.first.list.length;i++){
                    if(this.accept.first.list[i].index==other){
                        this.accept.first.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        //监听文件删除
        handleDel1(file,fileList){
              for(var i=0;i<this.accept.first.list.length;i++){
                if(this.accept.first.list[i].index==file.index){
                    for(var j=0;j<this.accept.first.list[i].files.length;j++){
                        this.accept.first.list[i].files.splice(j,1)
                    }
                }
            }
        },
       /**************终审款文件上传 */
               //监听上传文件
        //上传文件成功
        handleSuccess4(res, file,opt,other){
           if(res.code=='200'){
                // this.$message.success();
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.finall.list.length;i++){
                    if(this.accept.finall.list[i].index==other){
                        this.accept.finall.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        //监听文件删除
        handleDel4(file,fileList){
            for(var i=0;i<this.accept.finall.list.length;i++){
                if(this.accept.finall.list[i].index==file.index){
                    for(var j=0;j<this.accept.finall.list[i].files.length;j++){
                        this.accept.finall.list[i].files.splice(j,1)
                    }
                }
            }
        },
  

        /*************end */
      /**************质保款文件上传 */
       //监听上传文件
        handleChange2(file, fileList){
            // this.fileList = fileList.slice(-3);
            // console.log(fileList)
        },
        //上传文件成功
        handleSuccess2(res, file,opt,other){
           if(res.code=='200'){
                // this.$message.success();
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.quality.list.length;i++){
                    if(this.accept.quality.list[i].index==other){
                        this.accept.quality.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        //监听文件删除
        handleDel2(file,fileList){
              for(var i=0;i<this.accept.quality.list.length;i++){
                if(this.accept.quality.list[i].index==file.index){
                    for(var j=0;j<this.accept.quality.list[i].files.length;j++){
                        this.accept.quality.list[i].files.splice(j,1)
                    }
                }
            }
        },
      /*************end */
      /**************其他文件上传 */
       //监听上传文件
        handleChange3(file, fileList){
            // this.fileList = fileList.slice(-3);
            // console.log(fileList)
        },
        //上传文件成功
        handleSuccess3(res, file,opt,other){
                  if(res.code=='200'){
                // this.$message.success();
                var obj = {
                    uid:file.uid,
                    name:file.name,
                    url:base.httpCtx+res.data.saveUrls,
                    baseUrl:res.data.saveUrls,
                    index:other
                }
                for(var i=0;i<this.accept.otherFile.list.length;i++){
                    if(this.accept.otherFile.list[i].index==other){
                        this.accept.otherFile.list[i].files.push(obj)
                    }
                }
            }else{
                this.$message.error(res.msg);
            }
        },
        //监听文件删除
        handleDel3(file,fileList){
              for(var i=0;i<this.accept.otherFile.list.length;i++){
                if(this.accept.otherFile.list[i].index==file.index){
                    for(var j=0;j<this.accept.otherFile.list[i].files.length;j++){
                        this.accept.otherFile.list[i].files.splice(j,1)
                    }
                }
            }
        },      
        // 增加预付款
        add(){
            var list =this.accept.advanceCharge.list
            var length = list.length
            var ind = list[length-1].index
            var obj={payMoney:'',fileNmae:'',index:parseInt(ind)+1 ,time:''}
            list.push(obj)
        },
        reduce(index){
            var list =this.accept.advanceCharge.list
            list.splice(index, 1)
            // for (let i in list) {
            //     list[i].index = i       
            // }
            console.log(list.length)
            if(list.length==0){
                var obj={payMoney:'',fileNmae:'',index:1}
                this.accept.advanceCharge.list.push(obj)
            }
            this.getInputvalue()

        },
        // 进度款 - 添加
        add1(){
            var list =this.accept.first.list
            var ind = list[list.length-1].index
            var obj={payMoney:'',baseMoney:'',fileNmae:'',index:parseInt(ind)+1,apprMoney:'',damMoney:'',time:''}
            list.push(obj) 
        },
        // 进度款 - 删除
        reduce1(index){
            var list =this.accept.first.list
            var val = -1;
            for(var i=0;i<list.length;i++){
                if(list[i].index == index){
                    val = i
                }
            }
            list.splice(val, 1)
            if(list.length==0){
                var obj={payMoney:'',fileName:'',index:1}
                this.accept.first.list.push(obj)
            }
            this.getInputvalue1()
        },
        // 增加质量款
        add2(){
            var list =this.accept.quality.list
            var length = list.length
            var ind = list[length-1].index
            var obj={payMoney:'',fileNmae:'',index:parseInt(ind)+1 ,time:''}
            list.push(obj)
        },
        reduce2(index){
            var list =this.accept.quality.list
            list.splice(index, 1)
            for (let i in list) {
                list[i].index = i       
            }
            if(list.length==0){
                var obj={payMoney:'',fileNmae:'',index:1,}
                list.push(obj)
            }
            this.getInputvalue2()
            this.getInputvalue3()
        },
        // 终审
       add4(){
            var list =this.accept.finall.list
            var length = list.length
            var ind = list[length-1].index
            var obj={lastMoney:'',payMoney:'',fileNmae:'',index:parseInt(ind)+1 ,time:''}
            list.push(obj) 
        },
        reduce4(index){
            var list =this.accept.finall.list
            list.splice(index, 1)
            for (let i in list) {
                list[i].index = i       
            }
            if(list.length==0){
                var obj={payMoney:'',fileNmae:'',index:1 ,}
                list.push(obj) 
            }
           this.getInputvalue5()
           this.getInputvalue6()
           this.setLast()
        },
        // 其他
       add3(){
            var list =this.accept.otherFile.list
            var length = list.length
            var ind = list[length-1].index
            var obj={payMoney:'',fileNmae:'',index:parseInt(ind)+1 ,}
            list.push(obj) 
        },
        reduce3(index){
            var list =this.accept.otherFile.list
            list.splice(index, 1)
            for (let i in list) {
                list[i].index = i       
            }
            if(list.length==0){
                var obj={payMoney:'',fileNmae:'',index:0 ,}
                list.push(obj) 
            }
            // this.getInputvalue4()
          
        },
        
        changeStatus(e){
          console.log(e)
        },
        // 预付款
        getInputvalue(e){
          var list = this.accept.advanceCharge.list
          var total1 = 0
          for(var i = 0;i<list.length;i++){
              total1=list[i].payMoney==''?total1:total1+parseFloat(list[i].payMoney)
          }
           this.accept.advanceCharge.total1 = total1||0
        },
       // 初审款  
       getInputvalue1(e){
          var list = this.accept.first.list
          var total2 = 0
          for(var i = 0;i<list.length;i++){
              total2 = list[i].payMoney==''?total2:total2+parseFloat(list[i].payMoney)  
            
          }
          this.accept.first.total2 = total2
        },
         getInputvalue2(e){
          var list = this.accept.first.list
          var total3 = 0
          for(var i = 0;i<list.length;i++){
            total3 = !list[i].baseMoney||list[i].baseMoney==''?total3:total3+parseFloat(list[i].baseMoney)  
          }
         this.accept.first.total3 = total3
        },
        //进度款-审定产值
        getAppr1(){
            var list = this.accept.first.list
            var total2 = 0
            for(var i = 0;i<list.length;i++){
              total2 = !list[i].apprMoney||list[i].apprMoney==''?total2:total2+parseFloat(list[i].apprMoney)  
            }
            this.accept.first.total0 = total2
        },
        //进度款-违约金
        getDamages(){
            var list = this.accept.first.list
            var total2 = 0
            for(var i = 0;i<list.length;i++){
              total2 = !list[i].damMoney||list[i].damMoney==''?total2:total2+parseFloat(list[i].damMoney)  
            }
            this.accept.first.total4 = total2
        },
    //  质保款
         getInputvalue3(e){
          var list = this.accept.quality.list
          var total4 = 0
          for(var i = 0;i<list.length;i++){
              total4 = list[i].payMoney==''?total4:total4+parseFloat(list[i].payMoney)
            //   if(i==0){
            //       total4=parseInt(list[i].payMoney)  
            //   }else{
            //       total4+=parseInt(list[i].payMoney)  
            //   }
          }
          this.accept.quality.total4 = total4
        },
        // 终审款    
       getInputvalue5(e){
          var list = this.accept.finall.list
          var total5 = 0
          for(var i = 0;i<list.length;i++){
              total5 = list[i].payMoney==''?total5:total5+parseFloat(list[i].payMoney)
          }
          this.accept.finall.total5 = total5

        },
         getInputvalue6(e){
          var list = this.accept.finall.list
          var total6 = 0
          for(var i = 0;i<list.length;i++){
            total6 = !list[i].baseMoney|| list[i].baseMoney==''?total6:total6+parseFloat(list[i].baseMoney)
          }
         this.accept.finall.total6 = total6
        },
        //终审款 - 终审价
        setLast(){
            var list = this.accept.finall.list
            var total4 = 0
            for(var i = 0;i<list.length;i++){
                total4 = !list[i].lastMoney|| list[i].lastMoney==''?total4:total4+parseFloat(list[i].lastMoney)
            }
            this.accept.finall.total4 = total4
        },
        //获取招标资料
        getData1(){
            var that = this
            myHttp.getContractStageByProjectId({
                contractId:this.id,
                unitKind:this.unitKind,
                status:this.status,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    if(resp.data.data.object){
                        var data = resp.data.data.object
                        if(data){
                            for(var item in that.accept){
                                if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                    var str = JSON.parse(data[item])
                                    for(var k in that.accept[item]){
                                        if(str[k]){
                                            if(k=='list' && str[k].length==0){
                                                
                                            }else{
                                                that.accept[item][k] = str[k]
                                            }
                                        }
                                    }
                                }else if(data[item]){
                                    that.accept[item] = data[item]
                                }
                            }
                        }
                        console.log(JSON.stringify(that.accept))
                        // console.log(that.entity)
                    // var advanceCharge = JSON.parse(resp.data.data.object.advanceCharge)
                    // var first= JSON.parse(resp.data.data.object.first)
                    // var finall  =JSON.parse(resp.data.data.object.finall)
                    // var quality  =JSON.parse(resp.data.data.object.quality)
                    // var otherFile  =JSON.parse(resp.data.data.object.otherFile)
                    // var entity ={
                    //         contractId:that.id,
                    //         advanceCharge:advanceCharge,
                    //         first:first,
                    //         finall:finall,
                    //         quality:quality,
                    //         otherFile:otherFile,
                    // }
                            
                    // that.entity = entity
                    }
                }
            })
        },
           //获取合同信息
        getInfo(){
            var that = this
            myHttp.getContractById({
                id:this.id,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proContract
                    that.agreeName = data.entProjectName
                    that.unitKind = data.unitKind
                    that.getData1()
                }
            })
        },

        //解析list数据
        filterNull(data){
            var listNull = false
            for(var obj in data[0]){
                if(obj!='index'){
                    if(typeof data[0][obj]=='string' && data[0][obj]!=''){
                        listNull = true
                    }else if(Array.isArray(data[0][obj]) && data[0][obj].length>0){
                        listNull = true
                    }
                }
            }
            if(!listNull){
                data = []
            }
            return data
        },
        //保存
        onSubmit(){
            var that = this
            var data = JSON.parse(JSON.stringify(this.accept))
            var columnName = ''
            for(var item in data){
                for(var obj in data[item]){
                    if(obj=='list' && data[item][obj].length==1){
                        data[item][obj]=this.filterNull(data[item][obj])
                    }else if(obj!='flag' && obj!='list'){
                        if(data[item][obj]==''||data[item][obj]==0){
                            delete data[item][obj]
                        }
                    }
                }
                console.log(JSON.stringify(data[item]))
                if(!data[item].flag){
                    columnName = columnName==''?item:columnName+','+item
                }
            }
            // var data = {}
            data['contractId'] = this.id
            var opt = {
                contractId:this.id,
                unitKind:this.unitKind,
                updateBy:util.session.get('user').id,
                status:this.status,
                entity:data,
                columnName:columnName,
                type:7
            }
            myHttp.createOrupdateContract(opt).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    that.$store.commit('setRefrshAgree',true)
                    that.$message.success('保存成功');
                    that.getData1()
                }else{
                    that.$message.error(resp.data.msg);
                }
            })
        },


    },
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>
    @import '/layui/css/layui.css';
    .bid-box .el-form-item__content{
        text-align: left;
    }
    .bid-box .el-upload-list__item{
        margin: 0;
        width: 50%;
    }
    .bid-box .el-upload-list__item-name{
        height: 27px;
        display: flex;
        align-items: center;

    }
    .bid-box .el-icon-document{
        top: -5px;
    }
    
.recommends-content-item{
    /* width: 33%;
    height: 280px;
    margin-right: 1rem; */
    /* height: 15rem; */

    position: relative;
}
.recommends-content-item:hover .recommends-content-item__info{
    opacity: 1;
    transform:  translateY(0);
}
.recommends-content-item__info{
    /* position: absolute;
    bottom: 0;
    color: rgba(255, 255, 255, 0.8); */
    /* background: rgba(34,34,34,0.35); */
    padding: 0 0.5rem;
    text-align: center;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    transition: 0.3s;
    opacity: 0;
    transform:  translateY(100%);
}
.el-upload-list{
    width: 200px;
}
    .layui-table td{
        font-size: inherit;
        text-align: center;
        line-height: 30px;
    }
    .layui-table th{
        font-size: inherit;
        font-weight: bold;
        text-align: center;
    }

    .layui-table td, .layui-table th, .layui-table-col-set, .layui-table-fixed-r, .layui-table-grid-down, .layui-table-header, .layui-table-page, .layui-table-tips-main, .layui-table-tool, .layui-table-total, .layui-table-view, .layui-table[lay-skin=line], .layui-table[lay-skin=row]{
        border-color: #312e2e;
    }
</style>